<template>
  <datatable
      :type="'orders'"
      :rowData="orders"
      :loadingMessage="loadingMessage"
      :noRowsMessage="noRowsMessage"
      :columns="columns"
      :paginationSize="50"
  />
</template>

<script>
import datatable from "datatables/datatable";

export default {
  name: 'orders_awaiting_signature',
  components: { datatable },

  data() {
    return {
      orders: null,
      loadingMessage: 'Loading Orders Awaiting Signature...',
      noRowsMessage: 'No Orders Awaiting Signature Found',
      columns: [
        { headerName: 'Order Ref', field: 'order_ref', width: 110, suppressSizeToFit: true, pinned: 'left' },
        { headerName: 'Client Name', field: 'company_name', minWidth: 200, pinned: 'left' },
        { headerName: 'Order Date', field: 'date_of_order', minWidth: 110 },
        { headerName: 'Order Type', field: 'order_type', minWidth: 140 },
        { headerName: 'Position', field: 'job_title', minWidth: 160 },
        { headerName: 'Short Site Name', field: 'short_site_name', minWidth: 160 },
        { headerName: 'Location Address', field: 'job_address_full', minWidth: 250 },
        { headerName: 'VAT', field: 'site_vat_treatment', minWidth: 80 },
        { headerName: 'Main Contractor', field: 'site_main_contractor', minWidth: 150 },
        { headerName: 'Required', field: 'workers_required', minWidth: 100, filter: false },
        { headerName: 'Assigned', field: 'assignment_count', minWidth: 100, filter: false },
        { headerName: 'Start Date', minWidth: 110, valueGetter: this.start_date_value_getter },
        { headerName: 'End Date', minWidth: 110, valueGetter: this.end_date_value_getter },
        { headerName: 'Consultant', field: 'consultant_name', minWidth: 200 }
      ]
    };
  },

  mounted() {
    this.get_orders();
  },

  methods: {
    start_date_value_getter(params) {
      return this.$options.filters.formatDate?.(params.data.start_date) ?? params.data.start_date;
    },
    end_date_value_getter(params) {
      return this.$options.filters.formatDate?.(params.data.end_date) ?? params.data.end_date;
    },
    get_orders() {
      const url = this.crmApiPath + 'sunset/order-jobs/unsigned';
      axios
          .get(url, { params: { limit: 99999 } })
          .then(res => { this.orders = res.data; })
          .catch(() => { this.orders = []; });
    }
  }
};
</script>
